module.exports = __webpack_public_path__ + "static/media/aqwire.f530dd33.jpg";